import { Container } from "@mui/material";
import { ComponentHeader, VideoPlayer } from "@/components/ui";
import { PAGE_COPY } from "@/constants/pages";

export const AboutVideo = () => (
  <Container maxWidth="md">
    <ComponentHeader
      title={PAGE_COPY.sections.aboutVideo.title}
      subTitle={PAGE_COPY.sections.aboutVideo.subTitle}
    />
    <VideoPlayer video={PAGE_COPY.sections.aboutVideo.videoUrl} />
  </Container>
);
